import {
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';

interface CompaniesListWithPaymentSekeltonProps {
    skeletonArrayLenth?: number;
}

function CompaniesListWithPaymentSekelton({
    skeletonArrayLenth,
}: CompaniesListWithPaymentSekeltonProps) {
    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Skeleton variant="text" width="60%" />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width="40%" />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width="50%" />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width="30%" />
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array.from({ length: skeletonArrayLenth || 5 }).map((_, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <Skeleton variant="text" width="80%" />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width="60%" />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width="70%" />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width="50%" />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default CompaniesListWithPaymentSekelton;